export const NOT_PAID = 0
export const PAID = 1
